import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

interface SignupData {
  email: string;
  formLocation: string;
  source: string;
  userAgent: string;
  referrer: string;
}

export const signupApi = createApi({
  reducerPath: 'signupApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    addEmail: builder.mutation<{ id: string }, SignupData>({
      queryFn: async (data) => {
        try {
          const docRef = await addDoc(collection(db, 'signups'), {
            ...data,
            timestamp: serverTimestamp(),
          });
          return { data: { id: docRef.id } };
        } catch (error) {
          return { error: { status: 500, data: 'Failed to add email' } };
        }
      },
    }),
  }),
});

export const { useAddEmailMutation } = signupApi; 